import moment from "moment";

export default async function extractDate(url: string): Promise<string> {
  const dateRegex = /(\d{4}-\d{1,2}-\d{1,2}|\d{1,2}-\d{1,2}-\d{4})/;
  const tickpickRegex = /(\d{1,2}-\d{1,2}-25|\d{1,2}-\d{1,2}-26)/;
  let locale = url.includes(".com") || url.includes(".ca") ? "us" : undefined;
  let match;
  let extractedDate;

  if (url.includes("tickpick")) {
    match = url.match(tickpickRegex);
  } else {
    match = url.match(dateRegex);
  }

  if (!match && (url.includes("ticketmaster") || url.includes("livenation"))) {
    return "Shortened ticketmaster URL";
  } else if (!match) {
    return "Unable to find date in string";
  } else {
    if (url.includes("tickpick")) {
      extractedDate = moment(match[0], "M-D-YY").format("YYYY-MM-DD");
    } else {
      extractedDate = match[0];
    }
  }

  if (/^\d{1,2}-\d{1,2}-\d{4}$/.test(extractedDate)) {
    if (locale) {
      extractedDate = moment(extractedDate, "M-D-YYYY").format("YYYY-MM-DD");
    } else {
      extractedDate = moment(extractedDate, "D-M-YYYY").format("YYYY-MM-DD");
    }
    //In case US date on .ie
    if (!locale && extractedDate === "Invalid date" && match) {
      extractedDate = moment(match[0], "M-D-YYYY").format("YYYY-MM-DD");
    } else if (locale && extractedDate === "Invalid date") {
      // If date invalid on US urls
      extractedDate = moment(match[0], "D-M-YYYY").format("YYYY-MM-DD");
    }
  }

  return extractedDate;
}
